import { render, staticRenderFns } from "./sidebarnav.vue?vue&type=template&id=411f58fd"
import script from "./sidebarnav.vue?vue&type=script&lang=js"
export * from "./sidebarnav.vue?vue&type=script&lang=js"
import style0 from "./sidebarnav.vue?vue&type=style&index=0&id=411f58fd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports